<app-info [hasDevices]="hasDevices" [hasPermission]="hasPermission"></app-info>

<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>Done</button>
</mat-dialog-actions>
